export default __webpack_public_path__ + "static/media/banner2.a2f10aac.jpg";